/**
 * Format a rating number for BrandRating value display.
 * Whole numbers: "0"…"5" (no ".0"). Fractions: trim trailing zeros ("4.5", "4.25").
 */
export function formatRatingDisplay(value) {
  if (value == null || value === "") return "";
  var n = Number(value);
  if (!isFinite(n)) return "";
  if (Math.abs(n - Math.round(n)) < 1e-9) {
    return String(Math.round(n));
  }
  // Up to 2 decimal places, strip trailing zeros (4.50 → 4.5, 4.25 → 4.25).
  return String(parseFloat(n.toFixed(2)));
}

export default formatRatingDisplay;
